import { defineStore } from 'pinia'
import { ref } from 'vue'

/**
 * Queues one notification for MainLayoutM3, which shows it with the given
 * Quasar Notify type (position/lifetime come from shared/config/notify.js).
 */
export const useNotificationStore = defineStore('notification', () => {
  const message = ref()
  const type = ref()
  const idx = ref(0)

  function $reset () {
    message.value = null
    type.value = null
  }

  function success (msg) {
    type.value = 'positive'
    message.value = msg
    idx.value++
  }
  function error (msg) {
    type.value = 'negative'
    message.value = msg
    idx.value++
  }

  return { message, type, idx, success, error, $reset }
})
